import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { Tooltip } from "@mui/material";
import AddStudyMaterialToolTip from "../../../ContentManagement/LiveSession/LiveSessionDetail.js/AddStudyMaterialCM/AddStudyMaterialToolTip";
import { NavLink } from "react-router-dom";

const TimeTableEvents = ({ event }) => {
  const [activity, setActivity] = useState([]);
  const [homework, setHomework] = useState([]);
  const [preRead, setPreRead] = useState([]);
  const [assessment, setAssessment] = useState([]);

  useEffect(() => {
    const handleSupplementDetails = async () => {
      event?.Events?.forEach((obj) => {
        try {
          if (obj.name === "activity") {
            axios
              .get(`api/v1/homework/activity/getById/${obj.value}`)
              .then((res) => {
                res && setActivity(res.data.data);
              });
          }
          if (obj.name === "pre_read") {
            axios
              .get(`api/v1/homework/preRead/getById/${obj.value}`)
              .then((res) => {
                res && setPreRead(res.data.data);
              });
          }
          if (obj.name === "assessment") {
            axios.get(`api/v1/assessment/get/${obj.value}`).then((res) => {
              res && setAssessment(res.data.data);
            });
          }
          if (obj.name === "homework") {
            axios.get(`api/v1/homework/get/${obj.value}`).then((res) => {
              res && setHomework(res.data.data);
            });
          }
        } catch (error) {
          console.log("error");
        }
      });
    };
    handleSupplementDetails();
  }, [event]);

  const handleIconClick = (item) => {
    // Handle navigation using React Router's Link component
    // {/* Remove id from url */}
    switch (item.name) {
      case "pre_read":
        return `/PublishedQListPreRead`;
      case "activity":
        return `/PublishedQListActvity`;
      case "homework":
        return `/PublishedQListHW`;
      case "assessment":
        return `/PublishedQList`;
      default:
        break;
    }
  };

  return event ? (
    <>
      <div className="event-icons-container1 col-3">
        <div className="d-flex gap-2">
          {event?.Events?.map((item, index) => {
            let name = "";
            let description = "";
            let case1 = "";

            switch (item.name) {
              case "pre_read":
                name = preRead?.name || "";
                description = preRead?.description || "";
                case1 = "Pre_read";
                break;
              case "activity":
                name = activity?.name || "";
                description = activity?.description || "";
                case1 = "Activity";
                break;
              case "homework":
                name = homework?.name || "";
                description = homework?.description || "";
                case1 = "Homework";
                break;
              case "assessment":
                name = assessment?.name || "";
                description = assessment?.description || "";
                case1 = "Assessment";
                break;
              default:
                break;
            }

            return (
              <div
                key={index}
                className="mr-2"
                onClick={localStorage.setItem("from", "DCM")}
              >
                {/* Use Link component to handle navigation */}
                {/* Here I added state */}
                <NavLink
                  to={handleIconClick(item)}
                  state={{
                    homework_id: item.value,
                    assessmentId: item.value,
                    publishPre_id: item.value,
                    publishedActivity_id: item.value,
                    schedule_date: homework.schedule_date,
                  }}
                >
                  {name && description ? (
                    <AddStudyMaterialToolTip
                      case2={case1}
                      name={name}
                      description={description}
                    >
                      <img
                        src={`images/${item.name}Day1.svg`}
                        alt=""
                        className="icns"
                      />
                    </AddStudyMaterialToolTip>
                  ) : null}
                </NavLink>
              </div>
            );
          })}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default TimeTableEvents;
